module.exports = __webpack_public_path__ + "static/media/copyLinkIcon.2c12e231.svg";